import { CardColors } from './cards';
import { ATLAS_REGISTRY } from 'game/assets/generated';
import { Texture } from 'pixi.js';

export const colorsMap = ['diamonds', 'hearts', 'clubs', 'spades'];

/**
 * Get card texture from atlas
 * @param theme - card theme (e.g., "1_white", "13_classic")
 * @param code - card code (e.g., "A", "K", "2")
 * @param color - suit color (0-3: diamonds, hearts, clubs, spades)
 */
export async function getCardAsset(theme: string, code: string, color: CardColors): Promise<Texture> {
    let value = code.split('')[0];
    value = value.replace('T', '10');
    value = value.replace('A', 'ace');
    value = value.replace('J', 'j');
    value = value.replace('Q', 'q');
    value = value.replace('K', 'k');
    value = value.toLocaleLowerCase();
    const colorName = colorsMap[parseInt(color)];

    const textureName = `${value}-${colorName}.png`;
    
    try {
        const themePath = `front/${theme}`;
        
        for (const atlasClass of Object.values(ATLAS_REGISTRY)) {
            const atlas = atlasClass as any;
            const atlasPath = atlas.NAME || atlas.ATLAS_PATH;
            
            if (atlasPath && atlasPath.includes(themePath)) {
                if (atlas.TEXTURES && atlas.TEXTURES.includes(textureName)) {
                    return await atlas.getTextureByName(textureName);
                }
            }
        }
        
        throw new Error(`Texture ${textureName} not found in theme ${theme}`);
    } catch (error) {
        console.error(`Failed to get card asset: ${textureName} in theme ${theme}`, error);
        return Texture.EMPTY;
    }
}

/**
 * Get card back texture from atlas
 * @param theme - card back theme (e.g., "1_blue", "2_red")
 */


export async function getCardBackAsset(theme: string): Promise<Texture> {
    try {
        const textureName = `${theme}.png`;
        
        const allBackAtlases = Object.entries(ATLAS_REGISTRY)
            .filter(([key]) => key.includes('cards/backs'))
            .map(([_, atlas]) => atlas);

        for (const atlasClass of allBackAtlases) {
            const atlas = atlasClass as any;
            if (atlas.TEXTURES && atlas.TEXTURES.includes(textureName)) {
                return await atlas.getTextureByName(textureName);
            }
        }
        
        return Texture.EMPTY;
    } catch (error) {
        console.error(`Failed to get card back asset: ${theme}`, error);
        return Texture.EMPTY;
    }
}
